import React from 'react'
import { useLinkToolbarButton, useLinkToolbarButtonState } from '@udecode/plate-link/react'
import { BoxProps, IconButton } from '@ui'

type Props = {
    onClick?: () => void
    background?: BoxProps['background']
}
export const LinkToolbarButton = ({ onClick, background }: Props) => {
    const state = useLinkToolbarButtonState()
    const { props } = useLinkToolbarButton(state)

    return (
        <IconButton
            opaque
            active={props.pressed}
            icon="link"
            background={props.pressed ? 'level3' : background}
            tooltip="Link"
            tooltipOptions={{ placement: 'vertical', immediate: true }}
            onClick={onClick}
        />
    )
}
